export const FETCH_LIKES_YOU_PREVIEW = 'FETCH_LIKES_YOU_PREVIEW';
export const FETCH_LIKES_YOU_PREVIEW_REQUEST = 'FETCH_LIKES_YOU_PREVIEW_REQUEST';
export const FETCH_LIKES_YOU_PREVIEW_SUCCESS = 'FETCH_LIKES_YOU_PREVIEW_SUCCESS';
export const FETCH_LIKES_YOU_PREVIEW_ERROR = 'FETCH_LIKES_YOU_PREVIEW_ERROR';

export const FETCH_LIKES_YOU_COUNT = 'FETCH_LIKES_YOU_COUNT';
export const FETCH_LIKES_YOU_COUNT_REQUEST = 'FETCH_LIKES_YOU_COUNT_REQUEST';
export const FETCH_LIKES_YOU_COUNT_SUCCESS = 'FETCH_LIKES_YOU_COUNT_SUCCESS';
export const FETCH_LIKES_YOU_COUNT_ERROR = 'FETCH_LIKES_YOU_COUNT_ERROR';
export const UPDATE_LIKES_YOU_COUNT = 'UPDATE_LIKES_YOU_COUNT';

export const FETCH_LIKES_YOU_RECS = 'FETCH_LIKES_YOU_RECS';
export const FETCH_LIKES_YOU_RECS_REQUEST = 'FETCH_LIKES_YOU_RECS_REQUEST';
export const FETCH_LIKES_YOU_RECS_SUCCESS = 'FETCH_LIKES_YOU_RECS_SUCCESS';
export const FETCH_LIKES_YOU_RECS_ERROR = 'FETCH_LIKES_YOU_RECS_ERROR';

export const FETCH_LIKES_YOU_TEASERS = 'FETCH_LIKES_YOU_TEASERS';
export const FETCH_LIKES_YOU_TEASERS_REQUEST = 'FETCH_LIKES_YOU_TEASERS_REQUEST';
export const FETCH_LIKES_YOU_TEASERS_SUCCESS = 'FETCH_LIKES_YOU_TEASERS_SUCCESS';
export const FETCH_LIKES_YOU_TEASERS_ERROR = 'FETCH_LIKES_YOU_TEASERS_ERROR';

export const FAST_MATCH_LIKE = 'FAST_MATCH_LIKE';
export const FAST_MATCH_DISLIKE = 'FAST_MATCH_DISLIKE';
export const FAST_MATCH_SUPERLIKE = 'FAST_MATCH_SUPERLIKE';

export const SET_LAST_GOLD_HOME_TAB = 'SET_LAST_GOLD_HOME_TAB';
export const SHOW_NEW_LIKES_CELEBRATION_MODAL = 'SHOW_NEW_LIKES_CELEBRATION_MODAL';
export const SET_GOLD_HOME_SEEN = 'SET_GOLD_HOME_SEEN';
export const SET_NEW_LIKES_COUNT = 'SET_NEW_LIKES_COUNT';
export const SET_NEW_LIKES_COUNT_SUCCESS = 'SET_NEW_LIKES_COUNT_SUCCESS';
export const SET_PREVIOUS_SESSION_LIKES_COUNT = 'SET_PREVIOUS_SESSION_LIKES_COUNT';

export const LIKES_YOU_RECENTLY_ACTIVE_TEASER = 'recently-active';
